import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import VASCommandCenter from '../components/VASCommandCenter/VASCommandCenter';

const VASCommandCenterPage: React.FC = () => {
  const navigate = useNavigate();

  const handleCaseSelect = (caseId: string) => {
    navigate(`/exceptions?domain=vas&type=vik&caseId=${caseId}`);
  };

  const handleBackToDomains = () => {
    navigate('/domains');
  };

  const handleOpenWorkspace = () => {
    navigate('/exceptions?domain=vas&type=vik');
  };

  return (
    <div style={{ width: '100%', minHeight: '100vh', backgroundColor: '#fafafa' }}>
      {/* Simple header with back button */}
      <div style={{
        padding: '16px 24px',
        backgroundColor: 'white',
        borderBottom: '1px solid #e1dfdd',
        display: 'flex',
        alignItems: 'center',
        gap: '16px'
      }}>
        <Button
          appearance="subtle"
          icon={<ArrowLeftRegular />}
          onClick={handleBackToDomains}
        >
          Back to Workflows
        </Button>
        <div style={{
          fontSize: '20px',
          fontWeight: 600,
          color: '#242424'
        }}>
          VAS Commitment Command Center
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <Button appearance="primary" onClick={handleOpenWorkspace}>
            Open VIK Exception Workspace
          </Button>
        </div>
      </div>

      {/* Command Center content */}
      <VASCommandCenter onCaseSelect={handleCaseSelect} />
    </div>
  );
};

export default VASCommandCenterPage;
